import * as React from 'react'
import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Icon, IconSizeName } from '$views/components/Icon'
import { Block } from '$views/components/Layout/Block'
import { iconSize } from '$views/components/Icon/Icon'
import { Text } from '$views/components'

interface Props {
  className?: string
  urlImage?: string
  size?: SizeName
  clickable?: boolean
  onErrorImage?: string
  bordered?: boolean
  borderColor?: string
  bottomIcon?: string
  bottomIconSize?: IconSizeName
  justify?: any
  textImage?: string
}

const imgSize = {
  small: 48,
  smallNormal: 66,
  normal: 80,
  normalMedium: 96,
  medium: 120,
  big: 176,
  xbig: 224,
}

type SizeName = 'small' | 'smallNormal' | 'normal' | 'normalMedium' | 'medium' | 'big' | 'xbig'

export const StyledIcon = styled(Icon)`
  position: absolute;
  bottom: -${p => rem(iconSize[p.size] / 2 - 4)};
  left: 0;
  right: 0;
  margin: auto;
`

const RoundedImageRaw: React.SFC<Props> = ({
  urlImage,
  className,
  onErrorImage,
  bordered,
  borderColor,
  bottomIcon,
  bottomIconSize,
  justify,
  textImage,
  ...props
}) => {
  const addDefaultImage = event => {
    if (onErrorImage) event.currentTarget.src = onErrorImage
  }

  return (
    <Block flex justify={justify}>
      {urlImage && <img className={className} src={urlImage} onError={addDefaultImage} />}
      {!urlImage && textImage && (
        <Block className={className} flex alignItems="center" justify="center">
          <Text
            title={props.size !== 'xbig' ? true : false}
            homeHeader={props.size === 'xbig' ? true : false}
            color="darkGrey"
            weight="bold"
            cooper
          >
            {textImage.charAt(0)}
          </Text>
        </Block>
      )}
      {bottomIcon && <StyledIcon size={bottomIconSize ? bottomIconSize : 'xl'} content={bottomIcon} />}
    </Block>
  )
}

export const RoundedImage = styled(RoundedImageRaw)<Props>`
  max-width: ${p => (p.size ? rem(imgSize[p.size]) : rem(imgSize.normal))};
  max-height: ${p => (p.size ? rem(imgSize[p.size]) : rem(imgSize.normal))};
  width: ${p => (p.size ? rem(imgSize[p.size]) : rem(imgSize.normal))};
  height: ${p => (p.size ? rem(imgSize[p.size]) : rem(imgSize.normal))};
  border-radius: 100%;
  object-fit: cover;
  ${p =>
    p.clickable &&
    `
      cursor: pointer;
  `};
  ${p =>
    p.bordered &&
    `
    border: ${p.size === 'xbig' ? '3px' : '2px'} solid ${p.theme.colors.white};
    padding: ${p.size === 'xbig' ? '3px' : '2px'};
    background-color: ${p.theme.colors.white};
  `};
  ${p =>
    !p.urlImage &&
    p.textImage &&
    `
      background-color: ${p.theme.colors.lightGrey};

  `}
  ${p =>
    p.borderColor &&
    `
    border-color: ${p.theme.colors[p.borderColor]};
  `}
`



// WEBPACK FOOTER //
// ./src/views/components/RoundedImage/RoundedImage.tsx